<template>
  <div
    class="BaseSelectOptions"
    ref="Options"
    tabindex="-1"
    @keydown.prevent.up.down.tab.enter.esc="handleKeyDown($event.key)"
    @blur="$emit('blur')">
    <div
      v-for="(option, optionIndex) in options"
      class="BaseSelectOption"
      :class="{
        'selected': isSelected(option),
        'highlighted': (optionIndex === highlighted),
      }"
      :key="option.value"
      @click="$emit('select', option)">
      {{ option.label }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseSelectOptions',

  data() {
    return {
      highlighted: 0,
    };
  },

  props: {
    options:  { type: Array, required: true },
    selected: { type: Object, default: null },
    focused:  { type: Boolean, default: false },
  },

  watch: {
    focused(focused) {
      if (focused) {
        setTimeout(() => {
          this.$refs.Options.focus();
        }, 50);
      }
    },
  },

  methods: {
    isSelected(option) {
      return !!this.selected && (option.value === this.selected.value);
    },

    handleKeyDown(key) {
      if (key === 'Escape') {
        this.$emit('blur');
        return;
      }
      if (key === 'Enter') {
        this.$emit('select', this.options[this.highlighted]);
        return;
      }

      const persistKey = key === 'Tab' ? 'ArrowDown' : key;
      const incrementMap = {
        ArrowUp:   (this.highlighted === 0) ? (this.options.length - 1) : (this.highlighted - 1),
        ArrowDown: (this.highlighted === (this.options.length - 1)) ? 0 : (this.highlighted + 1),
      };
      this.highlighted = incrementMap[persistKey];
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/_variables';

.BaseSelectOptions {
  max-height: 200px;
  padding: 8px 0;
  color: $dark;
  font-weight: normal;
  text-transform: none;
  overflow-x: hidden;
  overflow-y: auto;
  outline: none;
}

.BaseSelectOption {
  padding: 12px 16px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  cursor: pointer;
  outline: none;
  transition: background .2s ease 0s;
  &.selected {
    background: rgba($dark-blue, .2) !important;
  }
  &:hover,
  &.highlighted {
    background: rgba($grey, .6);
  }
}
</style>
